import { render } from "./VisionPage.vue?vue&type=template&id=202e9070"
import script from "./VisionPage.vue?vue&type=script&lang=js"
export * from "./VisionPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__